import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Route, Switch } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import TaxInvoiceIndexPage from '../containers/TaxInvoices'

import appActions from '../redux/app/actions'

const { changeCurrent } = appActions

const TaxInvoicesPage = ({
  location,
	match
}) => {
  const dispatch = useDispatch()
	const current = useSelector(state => state.getIn(['App', 'current'])).toJS()
	const { pathname } = location

	useEffect(() => {
		if (current[0] !== 'tax_invoices') {
			dispatch(changeCurrent(['tax_invoices']))
		}
	}, [pathname])

	const path = match.url

  return (
		<Switch>
			<Route path={`${path}/`} component={TaxInvoiceIndexPage} exact />
		</Switch>
  )
}

TaxInvoicesPage.propTypes = {
  location: PropTypes.object.isRequired,
	match: PropTypes.object.isRequired
}

TaxInvoicesPage.defaultProps = {}

export default TaxInvoicesPage
